import { Brush03Icon, PlusSquareIcon, Settings02Icon } from "@vetty/icons";
import { Button, Select } from "@/components";
import {
  BRANDING_SCOPE_OPTIONS,
  BRANDING_STATUS_OPTIONS,
  type BrandingScopeFilter,
  type BrandingStatusFilter,
} from "../../_constants/branding.const";
import styles from "./BrandingToolbar.module.scss";

type BrandingToolbarProps = {
  scope: BrandingScopeFilter;
  status: BrandingStatusFilter;
  onScopeChange: (value: BrandingScopeFilter) => void;
  onStatusChange: (value: BrandingStatusFilter) => void;
  onCreateBrandClick: () => void;
};

export const BrandingToolbar = ({
  scope,
  status,
  onScopeChange,
  onStatusChange,
  onCreateBrandClick,
}: BrandingToolbarProps) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__left"]}>
        <div className={styles["comp__filters"]}>
          <Select
            size="medium"
            variant="secondary"
            value={scope}
            startContent={<Brush03Icon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onScopeChange(value as BrandingScopeFilter)}
          >
            {BRANDING_SCOPE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>

          <Select
            size="medium"
            variant="secondary"
            value={status}
            startContent={<Settings02Icon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onStatusChange(value as BrandingStatusFilter)}
          >
            {BRANDING_STATUS_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </div>
      </div>

      <div className={styles["comp__actions"]}>
        <Button
          size="medium"
          variant="primary"
          startContent={<PlusSquareIcon style={{ width: 20, height: 20 }} />}
          onClick={onCreateBrandClick}
        >
          Create branding
        </Button>
      </div>
    </div>
  );
};
